export const useAdvanced = () => {
    // Advanced mode?
    const urlParams = new URLSearchParams(window.location.search);
    const veryAdvanced = urlParams.get("veryAdvanced") !== null;
    const advanced = veryAdvanced || urlParams.get("advanced") !== null;

    return { advanced, veryAdvanced }
}